export default "__VITE_ASSET__BV9KR3OR__"